import { Outlet } from "react-router-dom";
import { LanguageSelector, Clock } from "../../Components"
import { frames, logos, useMediaQuery } from "../../Styles"

const DefLayout = () => {
  const mobile = useMediaQuery(`(max-width: 600px)`);

  return (
    <frames.DecorBg>
      <div style={{position:"absolute", right:"20px", top: "10px", zIndex: "2", display: "flex", alignItems: "center", gap: "20px"}}>
        <Clock/>
        <LanguageSelector isPrimary={false}/>
      </div>
      <frames.Def>
        <img alt="Freeda Logo" src={logos.freedaSolutions} style={{ width: !mobile? "600px" : "80%", marginBottom: "20px" }}/>
        <Outlet />
      </frames.Def>
    </frames.DecorBg>  
  )
}
 
export default DefLayout